/**
 * A helper class to help determine if a given HTTP status matches
 * at least one status or pattern from a list.
 */
class StatusChecker {

  /**
   * Determine if the specified HTTP status code matches
   * at least one status or pattern from an array of statues/patterns.
   *
   * A status can either be a string (e.g. '200') or a number (e.g. 200).
   *
   * A pattern should use 'X' or 'x' to signify a wildcard. e.g. ('2xx' will match a 200, 201, 204 etc).
   *
   * @param status
   * @param arrayOrObject - An array of statuses/patterns, or a single status/pattern.
   */
  static hasMatch(status, arrayOrObject) {
    if (!StatusChecker.isValidStatus(status)) {
      throw new Error(`"${status}" is not a valid status.`);
    }
    const list = Array.isArray(arrayOrObject) ? arrayOrObject : [arrayOrObject];
    list.forEach(pattern => {
      if (!StatusChecker.isValidPatternOrStatus(pattern)) {
        throw new Error(`"${pattern}" is not a valid status or pattern.`);
      }
    });
    return list.some(pattern => !!String(status).match(String(pattern).replace(/(x|X)/g, '.')));
  }

  /**
   * Returns true if the specified status is a valid status or pattern.
   * @param status
   * @returns {boolean}
   */
  static isValidPatternOrStatus(status) {
    return !!/^[0-9xX]{3}$/.exec(String(status));
  }

  /**
   * Returns true if the specified status is a valid status.
   * @param status
   */
  static isValidStatus(status) {
    return !!/^[0-9]{3}$/.exec(String(status));
  }
}

module.exports = StatusChecker;


// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-common-core/lib/status-checker.js